<template>
  <RegionIssueOverlay>
    <IssueFormShaftsV2
      :inspectionId="inspectionId"
      :issueId="issueId"
      :issueNavBackRoute="issueNavBackRoute"
      :organisationId="organisationId"
      :shaftId="shaftId"
    />
  </RegionIssueOverlay>
</template>
<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';

import IssueFormShaftsV2 from '@/components/shafts/issue_form.vue';
import RegionIssueOverlay from '@/components/regions/regions_issue_overlay.vue';

defineProps({
  organisationId: { type: String, required: true },
  inspectionId: { type: String, required: true },
  issueId: { type: String, required: true },
  shaftId: { type: String, required: true },
  setGroupId: { type: String, required: false, default: null },
  setNumber: { type: String, required: false, default: null },
});

const route = useRoute();

// Set back route based on props
const issueNavBackRoute = computed(() => {
  switch (true) {
    case isType('sets'):
      return 'shaftV2IssuesTypeSet';
    case isType('overview'):
      return Object.hasOwn(route.params, 'setGroupId') ? 'shaftV2IssuesOverviewGroup' : 'shaftV2IssuesOverview';
    case isType('stations'):
      return 'shaftV2IssuesTypeStation';
    default:
      return 'shaftV2IssuesTypeHme';
  }
});

function isType(type) {
  return route.fullPath.includes(type);
}
</script>
